module.exports = __webpack_public_path__ + "media/country_flags/gb-wls-fc2da977.png";